<template>
	<div class="license" style="font-size: 14px">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<el-card
			v-if="
				(current_view == 'ADD' ||
					current_view == 'EDIT' ||
					current_view == 'VIEW' ||
					current_view == 'RENEWAL_ADD') &&
				!previewLicenseDialog
			"
			shadow="none"
		>
			<el-row>
				<el-col :span="10" :offset="7">
					<div style="text-align: left; font-size: 16px">
						<b>{{
							current_view == "ADD"
								? "Add License"
								: current_view == "EDIT"
								? "Edit License"
								: current_view == "VIEW"
								? "View License"
								: current_view == "RENEWAL_ADD"
								? "Renewal Details"
								: ""
						}}</b>
					</div>
					<el-row>
						<el-col :span="24">
							<div style="margin-top: 20px">Location</div>
							<el-select
								class="select"
								v-model="location"
								filterable
								placeholder="Select Location"
								v-validate="'required'"
								name="Select Location"
								style="text-transform: capitalize; margin-top: 10px"
								:disabled="
									current_view == 'VIEW' || current_view == 'RENEWAL_ADD'
								"
							>
								<el-option
									v-for="item in locationItems"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Location`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Location`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<div style="margin-top: 20px">License</div>
							<el-select
								class="select"
								v-model="title"
								filterable
								placeholder="Select License Name"
								v-validate="'required'"
								name="Select License Name"
								style="text-transform: capitalize; margin-top: 10px"
								:disabled="
									current_view == 'VIEW' || current_view == 'RENEWAL_ADD'
								"
								@change="getSettingDetailsByID(title)"
								popper-class="select-dropdown-width"
							>
								<el-option
									v-for="item in licensesList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select License Name`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select License Name`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<div>
						<el-row>
							<el-col :span="24">
								<el-card
									style="
										border: 1px dashed;
										border-radius: 12px;
										margin-top: 20px;
										border-color: #d26300;
									"
									shadow="none"
								>
									<el-row style="margin-top: 20px; margin-bottom: 20px">
										<el-col :span="12">
											<el-button
												class="button-class-white"
												icon="el-icon-upload"
												@click="$refs.fileUploadSelector.click()"
												:disabled="current_view == 'VIEW'"
											>
												Upload
											</el-button>
											<div
												style="font-size: 12px; margin-top: 5px; color: #d26300"
											>
												Supported media : JPG, JPEG, PNG, and PDF
											</div>
											<input
												type="file"
												ref="fileUploadSelector"
												id="fileInput"
												accept=".jpeg, .jpg, .png, .pdf, .gif, .csv, .webp, .vnd.openxmlformats-officedocument.spreadsheetml.sheet, .vnd.ms-excel, .mp4, .mov, .wmv, .avi, .avchd, .flv, .f4v, .swf, .mkv, .webm, .mpg, .mp2, .mpeg, .mpe, .mpv"
												@change="upload_file_handler"
												style="display: none"
												multiple
											/>
										</el-col>
										<el-col :span="12">
											<ul
												style="font-size: 12px; list-style: none"
												v-for="(item, idx) in fileURLArray"
												:key="idx"
											>
												<li style="margin-bottom: 5px">
													<span>
														<img
															width="12px"
															src="../../../assets/icons/Document.png"
															style="cursor: pointer; margin-left: 5px"
														/>
													</span>
													<span
														style="margin-left: 5px; cursor: pointer"
														@click="preview_license(item, idx)"
														>{{
															item.fileDetails.name.length >= 20
																? `${item.fileDetails.name.substring(0, 15)}...`
																: item.fileDetails.name
														}}
													</span>
													<span
														><img
															:disabled="current_view == 'VIEW'"
															@click="delete_file_list(item)"
															width="12px"
															src="../../../assets/icons/close.png"
															style="cursor: pointer; margin-left: 5px"
															class="mt-1"
													/></span>
												</li>
											</ul>
										</el-col>
									</el-row>
								</el-card>
							</el-col>
						</el-row>
					</div>

					<el-row>
						<el-col :span="24">
							<div style="margin-top: 20px">Description (optional)</div>
							<el-input
								type="textarea"
								v-model="description"
								placeholder="Description"
								class="input-class"
								style="text-transform: capitalize; margin-top: 10px"
								:rows="4"
								:disabled="current_view == 'VIEW'"
							/>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<div style="margin-top: 20px">Issue Date</div>
							<el-date-picker
								style="margin-top: 10px; width: 95%"
								v-model="issue_date"
								type="date"
								placeholder="Select Date"
								class="date"
								format="dd-MMM-yyyy"
								:picker-options="datePickerOptions"
								:disabled="current_view == 'VIEW'"
								v-validate="'required'"
								name="Issue Date"
							>
							</el-date-picker>
							<p>
								<span
									:v-show="errors.has(`Issue Date`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Issue Date`) ? "This field is required" : ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<div style="margin-top: 20px">Expiry Date</div>
							<el-date-picker
								style="margin-top: 10px; width: 95%"
								v-model="expiry_date"
								type="date"
								placeholder="Select Date"
								class="date"
								format="dd-MMM-yyyy"
								:picker-options="fromDatePickerOptions"
								:disabled="current_view == 'VIEW' || !issue_date"
								v-validate="'required'"
								name="Expiry Date"
							>
							</el-date-picker>
							<p>
								<span
									:v-show="errors.has(`Expiry Date`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Expiry Date`) ? "This field is required" : ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row
						v-if="title && alert_reminder != null"
						style="margin-top: 10px"
					>
						<el-col :span="24">
							<span style="color: red">Note </span
							><span style="font-size: 13px"
								>- License renewal alert will be sent {{ alert_reminder }}
								{{ alert_reminder == 1 ? "day" : "days" }} before the expiry
								date</span
							>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="2" :offset="18">
							<el-button
								@click="$emit('close')"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col style="margin-bottom: 40px" :span="2" :offset="2">
							<el-button
								:disabled="current_view == 'VIEW'"
								@click="add_update_license"
								class="button-class"
							>
								{{
									current_view == "ADD"
										? "Add"
										: current_view == "EDIT"
										? "Update"
										: current_view == "RENEWAL_ADD"
										? "Add"
										: "Update"
								}}
							</el-button>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</el-card>
		<PreviewLicenses
			v-if="previewLicenseDialog"
			:previewLicenseDialog="previewLicenseDialog"
			@close="previewLicenseDialog = false"
			:imgObject="imgObject"
			:fileURLArray="fileURLArray"
			:currentItemIndex="currentItemIndex"
			@update:currentItemIndex="updateCurrentItemIndex"
		/>
	</div>
</template>

<script>
import formBuilderServices from "../../../services/formBuilderServices";
import PreviewLicenses from "./PreviewLicenses.vue";
import licenseManagementService from "../../../services/licenseManagementService";
import TaskSkeletonLoader from "../labourPlaninig/tasks/taskSkeletonLoader.vue";

var moment = require("moment");
let existingFileNames = new Set();
export default {
	props: {
		current_view: String,
		storeObj: Object,
		previewLicenseDialog: Boolean,
	},
	components: {
		PreviewLicenses,
		TaskSkeletonLoader,
	},
	data: () => ({
		isDomLoading: true,
		location: "",
		locationItems: [],
		title: "",
		license_name: "",
		fileURLArray: [],
		description: "",
		datePickerOptions: {
			firstDayOfWeek: 1,
			disabledDate(time) {
				const twoYearsAgo = new Date();
				twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
				return time.getTime() < twoYearsAgo.getTime();
			},
		},
		issue_date: "",
		expiry_date: "",
		renewal_alert: 1,
		renewal_alertItems: [],
		uploadedAttachments: [],
		location_name: "",
		imgObject: {},
		licensesList: [],
		isDragging: false,
		alert_reminder: null,
		currentItemIndex: 0,
	}),
	computed: {
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: (date) => {
					if (this.issue_date) {
						// Calculate 2 years from the issue_date
						const twoYearsLater = new Date(this.issue_date);
						twoYearsLater.setFullYear(twoYearsLater.getFullYear() + 2);
						// Disable dates that are more than 2 years from the issue_date
						return date > twoYearsLater || date <= this.issue_date;
					}
					return false;
				},
			};
		},
	},
	mounted() {
		this.get_location_list();
		this.getLicensesSettingsList();
		if (
			this.current_view == "EDIT" ||
			this.current_view == "VIEW" ||
			this.current_view == "RENEWAL"
		) {
			this.title = this.storeObj.license_name_info.id;
			this.issue_date = this.storeObj.issue_date;
			this.expiry_date = this.storeObj.expiry_date;
			this.description = this.storeObj.description;
			this.location = this.storeObj.location;
			this.location_name = this.storeObj.location_info.name;
			this.renewal_alert = this.storeObj.alert_before.split(" ")[0];
			this.get_image(this.storeObj.attachments_info);
		}
		if (this.current_view == "RENEWAL_ADD") {
			this.title = this.storeObj.license_name_info.id;
			this.location = this.storeObj.location;
		}
		for (let i = 1; i <= 90; i++) {
			this.renewal_alertItems.push({
				label: i,
				value: i,
			});
		}
		setTimeout(() => {
			this.$nextTick(() => {
				this.$forceUpdate();
			});
			this.$forceUpdate();
		}, 500);
	},
	methods: {
		updateCurrentItemIndex(newIndex) {
			this.currentItemIndex = null;
			this.currentItemIndex = newIndex;
			this.$forceUpdate();
		},
		getSettingDetailsByID(license) {
			let item = this.licensesList.filter((el) => el.id == license)[0];
			console.log(item, "a");
			licenseManagementService.fetchLicenseSettingByID(item.id).then((res) => {
				console.log(JSON.parse(res.data));
				this.alert_reminder = JSON.parse(res.data).alert_days;
			});
		},
		getLicensesSettingsList() {
			this.isDomLoading = true;
			this.licensesList = [];
			licenseManagementService.listLicensesNames(false).then((res) => {
				this.licensesList = JSON.parse(res.data);
				this.licensesList = [...this.licensesList].sort((a, b) =>
					a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
				);
				console.log(this.licensesList, "	this.licensesList");
				this.isDomLoading = false;
			});
		},
		preview_license(item, idx) {
			this.currentItemIndex = idx;
			this.imgObject = item;
			// this.previewLicenseDialog = true;
			this.$emit("preview_license_true");
		},
		calculateDaysRemaining(expiryDate) {
			const currentDate = moment();
			const expiryMoment = moment(expiryDate, "YYYY-MM-DD");
			const daysRemaining = expiryMoment.diff(currentDate, "days");
			return daysRemaining;
		},
		renew_license() {
			this.title = "";
			this.issue_date = "";
			this.expiry_date = "";
			this.description = "";
			this.location = "";
			this.location_name = "";
			this.renewal_alert = "";
			this.fileURLArray = [];
			this.$emit("open_renewal_add", this.storeObj);
		},
		get_image(arr) {
			arr.forEach(async (el) => {
				el.fileDetails = {
					name: "",
				};
				let params = {
					file_path: el.file_path,
					storage: "task",
				};
				await formBuilderServices.getAttachmentURL(params).then((res) => {
					el.src = JSON.parse(res.data).data;
				});
				el.fileDetails = {
					name: el.file_name,
				};
			});
			setTimeout(() => {
				this.fileURLArray = arr;
				if (this.current_view == "VIEW") {
					setTimeout(() => {
						this.$emit("preview_license_true");
					}, 100);
				}
			}, 100);
		},
		get_location_list() {
			formBuilderServices.listAllLocations().then((res) => {
				let locationItems = JSON.parse(res.data);
				this.locationItems = locationItems.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
			});
		},
		add_update_license() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.fileURLArray.length > 0) {
						this.upload_question_attachments_api();
					} else {
						this.call_save_form_api();
					}
				}
			});
		},
		call_save_form_api() {
			let uploadedAttachments = [];
			if (this.uploadedAttachments.length > 0) {
				for (let i = 0; i < this.uploadedAttachments.length; i++) {
					uploadedAttachments.push({
						file_name: this.uploadedAttachments[i].file_name,
						file_path: this.uploadedAttachments[i].file_path,
					});
				}
			}
			let count = [...this.fileURLArray].filter((el) => el.id);
			if (count.length > 0) {
				for (let i = 0; i < count.length; i++) {
					uploadedAttachments.push({
						id: count[i].id,
						file_name: count[i].file_name,
						file_path: count[i].file_path,
					});
				}
			}
			let title = this.licensesList.filter((el) => el.id == this.title)[0].name;
			let issue_date = moment(this.issue_date).format("YYYY-MM-DD");
			let expiry_date = moment(this.expiry_date).format("YYYY-MM-DD");
			let params = {
				license_name: {
					id: this.title,
					name: title,
				},
				license: {
					location: this.location,
					issue_date: issue_date,
					description: this.description,
					expiry_date: expiry_date,
					alert_before: `0 00:00:00`,
					escalation_type: "user",
					escalation_user: null,
					escalation_designations: [],
				},
				license_attachments: uploadedAttachments,
			};
			if (this.current_view == "EDIT") {
				params.license.id = this.storeObj.id;
			}
			this.$emit("call_api", params);
		},
		upload_question_attachments_api() {
			let count = [...this.fileURLArray].filter((el) => !el.id);
			if (count.length > 0) {
				const formData = new FormData();
				const fetchAndConvertToFile = async (url) => {
					try {
						if (url && typeof url === "object" && url.src) {
							const response = await fetch(url.src);
							const blob = await response.blob();
							const fileName = url.fileDetails.name;
							return new File([blob], fileName);
						} else {
							throw new Error("Invalid URL format");
						}
					} catch (error) {
						console.error("Error fetching or processing file:", error);
						throw error;
					}
				};
				const uploadPromises = [...this.fileURLArray]
					.filter((el) => !el.id)
					.map(async (url, index) => {
						try {
							const file = await fetchAndConvertToFile(url);
							formData.append("attachments", file);
						} catch (error) {
							console.error(
								`Error at index ${index} during file processing:`,
								error
							);
						}
					});
				Promise.all(uploadPromises)
					.then(() => {
						formBuilderServices
							.uploadQuestionAttachment(formData)
							.then((res) => {
								this.uploadedAttachments = JSON.parse(res.data).data;
								this.call_save_form_api();
							});
					})
					.catch((error) => {
						console.error("Error during file processing:", error);
					});
			} else {
				this.call_save_form_api();
			}
		},
		upload_file_handler(event) {
			const fileInput = event.target; // Accessing the input element from the event
			const files = Array.from(fileInput.files);
			if (files.length > 5) {
				alert("Please select up to 5 files only.");
				return;
			}
			files.forEach((file) => {
				const indexToRemove = this.fileURLArray.findIndex(
					(uploadedFile) => uploadedFile.fileDetails.name === file.name
				);
				if (indexToRemove !== -1) {
					this.fileURLArray.splice(indexToRemove, 1);
				}
			});
			this.fileURLArray = this.fileURLArray.concat(
				files.map((file) => ({
					fileDetails: file,
					src: URL.createObjectURL(file),
				}))
			);
		},
		delete_file_list(item) {
			if (item.id) {
				let params = {
					id: item.id,
				};
				licenseManagementService
					.deleteLicenseAttachments(params)
					.then((res) => {
						console.log(res, "res");
					});
			}
			const indexToRemove = this.fileURLArray.findIndex(
				(file) => file.fileDetails.name === item.fileDetails.name
			);
			if (indexToRemove !== -1) {
				this.fileURLArray.splice(indexToRemove, 1);
			}
			const fileInput = this.$refs.fileUploadSelector;
			fileInput.value = null;
			this.$notify.success({
				title: "Success",
				message: "Attachment Deleted Successfully",
				type: "Success",
			});
		},
	},
};
</script>

<style>
.button-class-white {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
	overflow: visible;
	position: relative;
}
.button-class-white2 {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
}
.button-class {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
	overflow: visible;
	position: relative;
}
.license {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
}
.el-select.select {
	border-radius: 12px !important;
	font-size: 12px;
	width: 100%;
}
.el-select.select .el-input {
	border-radius: 12px !important;
	width: 100%;
	font-size: 12px;
}
.el-select.select .el-input .el-input__inner {
	border-radius: 12px !important;
	width: 100%;
	font-size: 12px;
	padding-left: 20px;
}
.el-select.select1 .el-input .el-input__inner {
	border-radius: 12px !important;
	width: 100%;
	border-color: #d26300;
	max-height: 30px;
	font-size: 12px;
	padding-left: 20px;
}
.el-select.select1 .el-input .el-select__caret {
	margin-top: 6px;
	font-size: 12px;
}
.input-class .el-input__inner {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 10px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	font-size: 12px;
}
.el-textarea .el-textarea__inner {
	display: block;
	resize: vertical;
	padding: 5px 15px;
	line-height: 1.5;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	width: 100%;
	font-size: inherit;
	color: #606266;
	background-color: #fff;
	background-image: none;
	border: 1px solid #dcdfe6;
	border-radius: 12px;
	-webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.date .el-input__inner {
	border-radius: 12px;
}
.el-select-dropdown__list {
	width: 300px !important; /* Ensure dropdown width is auto */
	min-width: 100% !important; /* Set minimum width to match the select input */
	overflow-x: auto;
}
</style>
